export class Adulto {
    id: string;
    nombre: string;
    rut: string;
    actividad: string;
    estudios: string;

    datosContacto:{} = {};
    
}